"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRoadmapResource = handleRoadmapResource;
const getState_1 = require("../../../app/dist/getState");
const dist_1 = require("../../../fs/dist");
const dist_2 = require("../../../core/dist");
const dist_3 = require("../../../fs/dist");
const fs = __importStar(require("fs-extra"));
const stateCache_1 = require("../stateCache");
/**
 * `loom://roadmap` — the derived cross-weave roadmap. A thin renderer over the
 * pure `buildRoadmap(state)` read-model in core: roadmap (present+future in one
 * topo + priority order, status per-node), history (shipped plans newest first),
 * and diagnostics (cycles, dangling deps, threads missing thread.md).
 * Reuses the unfiltered full-state cache (the same hot path as loom://state).
 * Pure read — never mutates.
 */
async function handleRoadmapResource(root, uri) {
    const startedAt = Date.now();
    (0, stateCache_1.initStateCache)(root);
    let state = (0, stateCache_1.getCachedState)();
    if (!state) {
        const registry = new dist_3.ConfigRegistry();
        state = await (0, getState_1.getState)({ getActiveLoomRoot: dist_1.getActiveLoomRoot, loadWeave: dist_1.loadWeave, buildLinkIndex: dist_1.buildLinkIndex, registry, fs, workspaceRoot: root });
        (0, stateCache_1.setCachedState)(state);
    }
    const roadmap = (0, dist_2.buildRoadmap)(state);
    process.stderr.write(`[roadmap] read uri=${uri} totalMs=${Date.now() - startedAt}\n`);
    return {
        contents: [{ uri, mimeType: 'application/json', text: JSON.stringify(roadmap, null, 2) }],
    };
}
